// extracted by mini-css-extract-plugin
export var container = "_50-0";
export var icon = "_50-1";
export var text = "_50-2";